import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "./index.scss";
import calendarIcon from "../../../images/bitcoin-live/calendar.svg";

const DateSelector = (props) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (props.clear) {
      setDateRange([null, null]);
    }
  }, [props.clear]);

  return (
    <div className="memberDatePicker">
      <img className="calenderSvg" src={calendarIcon} />
      <DatePicker
        // showIcon
        style={{
          border: "1px solid grey",
          borderRadius: "5px",
          boxShadow: "none",
        }}
        selectsRange={true}
        customStyles={{
          dateIcon: {
            width: 30,
            height: 30,
          },
        }}
        placeholderText="Filter By Date"
        startDate={startDate}
        endDate={endDate}
        onChange={(update) => {
          setDateRange(update);
          props.selectedDates(update);
        }}
        isClearable={true}
        showYearDropdown
        showMonthDropdown
        scrollableYearDropdown
        scrollableMonthDropdown
      />
    </div>
  );
};

export default DateSelector;
